'use client';

import React, { Suspense } from "react";
import Last7Days from "@/app/components/Last7Days";
import TabbedNewsSection from "@/app/components/TabbedNewsSection";
import AdvertisementImage from "@/app/modules/Advertisement";
import { useSearchParams } from "next/navigation";

function Content() {
  const searchParams = useSearchParams();
  const category = searchParams?.get("category") || null;
  const search = searchParams?.get("search") || null;

  return (
    <>
    <div className="mt-5 px-3 md:px-0 container mx-auto rounded">
      <div className="grid grid-cols-10 gap-4 ">
        <div className="flex flex-col col-span-10 md:col-span-7">
          <Last7Days categoryPk={category} search={search} />
        </div>

        <div className="flex col-span-10 md:col-span-3 flex-col">
          <div className="rounded overflow-hidden">
            <AdvertisementImage code={"news_top"} width={500} height={500} />
          </div>

          <TabbedNewsSection />

          <div className="rounded overflow-hidden mt-6">
            <AdvertisementImage code={"news_bottom"} width={500} height={500} />
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default function CategoryPage() {
  return (
    <Suspense fallback={<div>Уншиж байна...</div>}>
      <Content />
    </Suspense>
  );
}